import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@dhl/theme'

export const FlagNL: FC<SvgIconProps> = (props) => (
  <SvgIcon width={24} height={20} viewBox="0 0 9 6" {...props}>
    <rect fill="#21468B" width="9" height="6" />
    <rect fill="#FFF" width="9" height="4" />
    <rect fill="#AE1C28" width="9" height="2" />
  </SvgIcon>
)
